import { createContext } from 'react'

const splitpaymentContext = createContext()

export default splitpaymentContext
